import Layout from '@/components/feature/Layout';
import Seo from '@/components/base/Seo';
import Breadcrumb from '@/components/base/Breadcrumb';
import { siteInfo } from '@/mocks/anime';
import ContactForm from './components/ContactForm';

const stats = [
  { num: '560+', label: '精选番剧' },
  { num: '120万+', label: '累计访问' },
  { num: '9.0+', label: '平均评分' },
  { num: '6', label: '热门分类' },
];

const reviews = [
  { name: '二次元老粉·阿杰', role: '动漫爱好者', text: '用了动漫网之后，找番真的方便太多了，收藏入口地址一键直达，再也不用到处搜了。', rating: 5 },
  { name: '补番达人·小满', role: 'B站 UP 主', text: '分类很清晰，补番指南写得也很用心，强推给身边所有二次元朋友。', rating: 5 },
  { name: '上班族·小鹿', role: '治愈番爱好者', text: '治愈分类简直是我的避风港，下班回家看一集，一天的疲惫都烟消云散了。', rating: 4 },
];

export default function About() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于我们 - 动漫网',
      url: `${siteInfo.url}/about`,
      description: '动漫网是一家专注于动漫网址收藏、分类直达与内容推荐的二次元导航网站，致力于让每一位二次元爱好者都能快速找到想看的番剧。',
      inLanguage: 'zh-CN',
    },
  ];

  return (
    <Layout>
      <Seo
        title="关于我们 - 动漫网官网首页 | 品牌介绍与联系方式"
        description="了解动漫网品牌故事与口碑。动漫网专注动漫网址收藏、分类直达与内容推荐，收藏动漫网入口地址，想看番直接进。"
        path="/about"
        jsonLd={jsonLd}
      />

      <div className="bg-gradient-to-br from-primary-100 via-background-100 to-accent-100 pt-24 pb-8">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
          <Breadcrumb items={[{ name: '首页', path: '/' }, { name: '关于我们' }]} />
          <h1 className="mt-3 font-heading text-3xl text-foreground-950">关于动漫网</h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">品牌介绍、口碑与联系方式，一起认识更真实的动漫网。</p>
        </div>
      </div>

      {/* 品牌介绍 */}
      <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=team%20of%20passionate%20anime%20fans%20working%20together%20in%20a%20cozy%20studio%20with%20anime%20posters%20on%20wall%2C%20warm%20coral%20and%20amber%20lighting%2C%20clean%20vector%20illustration%2C%20friendly%20collaborative%20atmosphere&width=1200&height=900&seq=about-intro&orientation=portrait"
              alt="动漫网团队与品牌介绍"
              title="关于动漫网 - 二次元快乐入口"
              className="w-full object-cover"
            />
          </div>
          <div>
            <p className="text-sm font-medium text-primary-600">BRAND STORY</p>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">把动漫网入口地址握在手里</h2>
            <div className="mt-4 space-y-4 text-sm leading-relaxed text-foreground-700">
              <p>
                动漫网是一个专注于二次元的导航收藏平台。我们的初心很简单：让大家不用再为了找一部番剧而在搜索引擎里来回折腾，收藏动漫网官网首页直达链接，想看番直接进。
              </p>
              <p>
                我们精心整理了动漫网网址收藏、直达链接与主页导航，覆盖热血、恋爱、奇幻、科幻、悬疑、治愈六大热门分类。无论你是资深的二次元老粉，还是刚入坑的新人，都能在这里快速找到属于自己的快乐。
              </p>
              <p>
                未来，动漫网将持续深耕内容推荐与社区建设，让每一次点开动漫网入口，都成为一段愉悦的二次元旅程。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 数据口碑 */}
      <section className="bg-background-100/70 py-10">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-50 p-6 text-center">
                <p className="font-heading text-3xl text-primary-600">{s.num}</p>
                <p className="mt-1 text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-10">
        <div className="text-center">
          <p className="text-sm font-medium text-secondary-600">REPUTATION</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">用户口碑</h2>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {reviews.map((r) => (
            <figure key={r.name} className="rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-1 text-secondary-500" aria-label={`${r.rating} 星`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`${i < r.rating ? 'ri-star-fill' : 'ri-star-line'} text-sm`} aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-sm font-medium text-background-50">
                  {r.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-400">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* 联系方式 */}
      <section className="bg-gradient-to-br from-primary-100 via-background-100 to-accent-100 py-10">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-2">
          <div>
            <p className="text-sm font-medium text-accent-600">CONTACT US</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              无论是番剧推荐、合作洽谈还是意见建议，都欢迎通过以下方式与动漫网取得联系。
            </p>
            <div className="mt-6 space-y-4">
              {[
                { icon: 'ri-mail-line', label: '邮箱', value: siteInfo.email },
                { icon: 'ri-phone-line', label: '电话', value: siteInfo.phone },
                { icon: 'ri-map-pin-2-line', label: '地址', value: siteInfo.address },
                { icon: 'ri-time-line', label: '工作时间', value: '周一至周日 9:00 - 21:00' },
              ].map((c) => (
                <div key={c.label} className="flex items-center gap-4 rounded-lg bg-background-50 p-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${c.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <p className="text-xs text-foreground-400">{c.label}</p>
                    <p className="text-sm font-medium text-foreground-900">{c.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading text-xl text-foreground-950">在线留言</h3>
            <p className="mt-1 text-sm text-foreground-500">填写表单，我们会尽快回复您。</p>
            <div className="mt-5">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}